module.exports = __webpack_public_path__ + "cc70dc22137e92aaef169e1de38a6ec7.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-Regular.ttf
// module id = 425
// module chunks = 0